import { NavLink } from "react-router";
import { cn } from "@/lib/utils/cn";
import { SimpleTooltip } from "@/components/ui/tooltip";
import type { NavItem } from "./nav";

type Props = { items: NavItem[]; collapsed?: boolean; onNavigate?: () => void; className?: string };

export function NavList({ items, collapsed = false, onNavigate, className }: Props) {
  return (
    <ul className={cn("flex flex-col gap-0.5", className)}>
      {items.map((item) => {
        const link = (
          <NavLink
            to={item.to}
            onClick={onNavigate}
            className={({ isActive }) =>
              cn(
                "group flex h-10 items-center gap-3 rounded-md px-3 text-sm font-medium text-fg-muted transition-colors hover:bg-surface-2 hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50",
                isActive && "bg-accent/10 text-accent hover:bg-accent/15 hover:text-accent",
                collapsed && "justify-center px-0",
              )
            }
          >
            <item.icon className="size-5 shrink-0" aria-hidden />
            {!collapsed && <span className="truncate">{item.label}</span>}
          </NavLink>
        );
        return (
          <li key={item.to}>
            {collapsed ? (
              <SimpleTooltip label={item.label} side="right">
                {link}
              </SimpleTooltip>
            ) : (
              link
            )}
          </li>
        );
      })}
    </ul>
  );
}
